import React, { useEffect, useState } from 'react';
import '../../../styles/globals.css'
import { Box, Card, CardContent, CardActions, Button, Typography, Alert } from '@mui/material'
import { useKarmaPoolContext } from '../../../state/KarmaPoolContext';
import { Image } from '@mui/icons-material';
import { Link } from 'react-router-dom';

function CauseCardComponent(props) {

    const karmaContext = useKarmaPoolContext();

    function AddToken() {
        if (!isMember) {
            alert("Become a member to gain tokens.")
            return;
        }

        if (causeLoading) {
            return;
        }

        karmaContext.causeManager.addTokenToCause(props.name, 1);
    }

    function RemoveToken() {
        if (!isMember) {
            return;
        }

        if (causeLoading) {
            return;
        }

        if (karmaContext.causeManager.getCause(props.name)["tokensAllocatedToCycleByUser"] > 0) {
            karmaContext.causeManager.addTokenToCause(props.name, -1);
        }
    }

    const [causeLoading, setCauseLoading] = useState(true);

    useEffect(() => {
        if (causeLoading && !karmaContext.causeManager.getCause(props.name).loading) {

        }

        setCauseLoading(karmaContext.causeManager.getCause(props.name).loading);
    }, [karmaContext.local]);

    const [tokensAllocatedToCycleByUser, setTokensAllocatedToCycleByUser] = useState(0);

    useEffect(() => {
        setTokensAllocatedToCycleByUser(karmaContext.causeManager.getCause(props.name)["tokensAllocatedToCycleByUser"]);
    }, [karmaContext.local]);

    const [gbpRaisedToCycleByUser, setGBPRaisedToCycleByUser] = useState(-1);
    const [gbpRaisedToCycleByUserDisplay, setGBPRaisedToCycleByUserDisplay] = useState(-1);

    useEffect(() => {
        let amount = (Math.round((karmaContext.causeManager.getCause(props.name)["gbpRaisedToCycleByUser"] * 100)) / 100);

        if (isNaN(amount)) {
            return;
        }

        if (gbpRaisedToCycleByUserDisplay === -1) {
            setGBPRaisedToCycleByUserDisplay(amount);
        }

        setGBPRaisedToCycleByUser(amount);
    }, [karmaContext.local]);

    const [gbpRaisedToCycleTotal, setGBPRaisedToCycleTotal] = useState(10);
    const [gbpRaisedToCycleTotalDisplay, setGBPRaisedToCycleTotalDisplay] = useState(-1);

    useEffect(() => {
        let amount = (Math.round((karmaContext.causeManager.getCause(props.name)["gbpRaisedToCycleTotal"] * 100)) / 100);

        if (isNaN(amount)) {
            return;
        }

        if (gbpRaisedToCycleTotalDisplay === -1) {
            setGBPRaisedToCycleTotalDisplay(amount);
        }

        setGBPRaisedToCycleTotal(amount);
    }, [karmaContext.local]);

    useEffect(() => {
        return lerpValues(gbpRaisedToCycleByUser, gbpRaisedToCycleByUserDisplay, setGBPRaisedToCycleByUserDisplay);
    }, [gbpRaisedToCycleByUserDisplay, gbpRaisedToCycleByUser]);

    useEffect(() => {
        return lerpValues(gbpRaisedToCycleTotal, gbpRaisedToCycleTotalDisplay, setGBPRaisedToCycleTotalDisplay);
    }, [gbpRaisedToCycleTotalDisplay, gbpRaisedToCycleTotal]);

    function lerpValues(valueGet, valueDisplayGet, valueSet) {
        console.log("valueGet " + valueGet + " valueDisplayGet " + valueDisplayGet);
        if (valueGet === -1) {
            return;
        }

        const timer = setInterval(() => {
            if (valueDisplayGet === valueGet) {
                return;
            }

            let diff = valueGet - valueDisplayGet;

            if (Math.abs(diff) < 0.1) {
                valueSet(valueGet);
                return;
            }

            let lerp = diff * 0.1;

            console.log("lerp to " + (valueDisplayGet + lerp));
            valueSet(valueDisplayGet + lerp);
        }, 5);

        return () => clearInterval(timer);
    }

    const [isMember, setIsMember] = useState(false);

    useEffect(() => {
        setIsMember(karmaContext.local.user.member);
    }, [karmaContext.local.user]);


    return (
        <Box sx={{ width: "100%", display: "flex", justifyContent: props.justifyContent, alignItems: "center" }} >
            <Card sx={{
                width: "100%",
                maxWidth: "17.5rem",
                minWidth: "17.5rem",
                backgroundColor: "rgba(221, 221, 221, 0.075)",
                borderRadius: "0.25rem",
                borderColor: "rgba(221, 221, 221, 0.25)",
                border: "1px solid rgba(221, 221, 221, 0.35)"
            }}>
                <CardContent sx={{ marginBottom: "0rem" }}>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Box sx={{ width: "175px", height: "105px", border: "1px solid rgba(221, 221, 221, 0.35)", marginTop: "0.25rem" }} >
                            {/* add props.logo image to box */}
                            <a href={props.url} target="_blank" rel="noreferrer">
                                <img src={props.logo} alt="logo" width={175} height={105} />
                            </a>
                        </Box>
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ marginTop: "1.0em", color: "whitesmoke" }}>
                        You're currently giving:
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ marginTop: "0.5em", color: "whitesmoke" }}>
                        <strong>
                            {causeLoading ?
                                "please wait, loading" :
                                tokensAllocatedToCycleByUser + " tokens worth £" + gbpRaisedToCycleByUserDisplay.toFixed(2)} </strong>
                    </Typography>
                </CardContent>
                <CardActions sx={{ "justifyContent": "center", paddingTop: "0rem" }}>
                    <Button onClick={AddToken} size="small">add token</Button>
                    <Button onClick={RemoveToken} size="small">remove token</Button>
                </CardActions>
            </Card>
        </Box >
    );

}

export default CauseCardComponent;